import { useQuery } from '@tanstack/react-query';
import { OnboardingStatus } from 'src/context/types';
import { getOnboardingStatus } from 'src/services/apis/services';
import { QUERIES } from 'src/utils/react-query';

export function useOnboardingStatus(enabled = true) {
  return useQuery<OnboardingStatus>({
    queryKey: [QUERIES.ONBOARDING_STATUS],
    queryFn: () => getOnboardingStatus() as unknown as Promise<OnboardingStatus>,
    enabled,
    staleTime: 30_000,
  });
}
